"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currencyConverter = exports.initialCurrencyConverterState = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxAct = require("redux-act");

var _ramda = require("ramda");

var _currencyConverter = require("./currencyConverter.actions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var initialCurrencyConverterState = {
  conversions: {}
};
exports.initialCurrencyConverterState = initialCurrencyConverterState;
var currencyConverter = (0, _reduxAct.createReducer)({}, initialCurrencyConverterState).on(_currencyConverter.convertCurrencyRequest, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    conversions: _objectSpread(_objectSpread({}, state.conversions), {}, {
      [payload.id]: _objectSpread(_objectSpread({}, state.conversions[payload.id]), {}, {
        isLoading: true
      })
    })
  });
}).on(_currencyConverter.convertCurrencySuccess, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    conversions: _objectSpread(_objectSpread({}, state.conversions), {}, {
      [payload.id]: _objectSpread(_objectSpread({}, state.conversions[payload.id]), {}, {
        isLoading: false,
        result: payload.conversions
      })
    })
  });
}).on(_currencyConverter.convertCurrencyFail, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    conversions: _objectSpread(_objectSpread({}, state.conversions), {}, {
      [payload.id]: _objectSpread(_objectSpread({}, state.conversions[payload.id]), {}, {
        isLoading: true
      })
    })
  });
}).on(_currencyConverter.removeConversion, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    conversions: _objectSpread({}, (0, _ramda.omit)(["".concat(state.conversions[payload.id])], state.conversions))
  });
});
exports.currencyConverter = currencyConverter;